/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA / RNA Molecular Weight Calculator`)
};

const es_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Molecular de ADN / ARN`)
};

const de_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA-/RNA-Molekulargewichtsrechner`)
};

const nl_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA-/RNA-molecuulgewichtcalculator`)
};

const fr_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de masse moléculaire ADN / ARN`)
};

const it_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore del peso molecolare di DNA / RNA`)
};

const pt_br2_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Molecular de DNA / RNA`)
};

const pt_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Massa Molecular de ADN / ARN`)
};

const ja_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA / RNA分子量計算ツール`)
};

const zh_dnamw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA / RNA 分子量计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_h1", locale)
	if (locale === "en") return en_dnamw_h1(inputs)
	if (locale === "es") return es_dnamw_h1(inputs)
	if (locale === "de") return de_dnamw_h1(inputs)
	if (locale === "nl") return nl_dnamw_h1(inputs)
	if (locale === "fr") return fr_dnamw_h1(inputs)
	if (locale === "it") return it_dnamw_h1(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_h1(inputs)
	if (locale === "pt") return pt_dnamw_h1(inputs)
	if (locale === "ja") return ja_dnamw_h1(inputs)
	return zh_dnamw_h1(inputs)
};